import React, { useCallback, useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useIntl } from "react-intl";
import { messages } from "./Recording.messages";
import { useBlocks, useUi } from "@jelly/lesson";

import styles from "./Recording.module.scss";
import { BioModal } from "@src/lms/jelly/extensions/layouts/_lesson/case4/components/BioModal";
import config from "appConfig";

export const Recording: React.FC = () => {
  const ui = useUi();

  const blocks = useBlocks();
  const { formatMessage } = useIntl();

  const [BioModalOpen, setBioModalOpen] = useState(false);

  const handleBioModalToggle = useCallback(() => setBioModalOpen((open) => !open), []);

  const leftComponent = (
    <div className={styles.leftComponent}>
      <div style={{ width: "100%", height: "142px" }}>
        <blocks.video src={"https://youtu.be/reL5AGu6N6A"} provider={"youtube"} />
      </div>
      <ui.Button shape={"normal"} theme={"primary"} size={"small"} onClick={handleBioModalToggle}>
        {formatMessage(messages.C4_P3_S1_Bio_Button_Label)}
      </ui.Button>
    </div>
  );

  return (
    <div className={styles.root}>
      <StandardCase title={formatMessage(messages.C4_P3_S1_Title)} leftComponent={leftComponent}>
        <div className={styles.rightComponent}>
          <div key={1} className={styles.carouselItem}>
            <blocks.image src={`${config.STATIC_ASSETS_URL}/lms/case/case04/composition2.png`} />
            {/* <p className={styles.caption}>{formatMessage(messages.C4_P3_S1_Image_Caption1)}</p> */}
          </div>
          ,
        </div>
      </StandardCase>
      <BioModal
        visible={BioModalOpen}
        onClose={handleBioModalToggle}
        title={formatMessage(messages.C4_P3_S1_Bio_Title)}
        description={formatMessage(messages.C4_P3_S1_Bio_Text)}
        link="www.sebastianbartmann.com"
        linkLabel={formatMessage(messages.C4_P3_S1_Link_Label)}
      />
    </div>
  );
};
